import { basicEnum } from "./base";

export const PaymentChannelEnum = basicEnum([
    {
        label: "BCA Virtual Account",
        value: "BCA",
    },
    {
        label: "BNI Virtual Account",
        value: "BNI",
    },
    {
        label: "BSI Virtual Account",
        value: "BSI",
    },
    {
        label: "Mandiri Virtual Account",
        value: "MANDIRI",
    },
    {
        label: "Permata Virtual Account",
        value: "PERMATA",
    },
    {
        label: "BNC Virtual Account",
        value: "BNC",
    },
    {
        label: "OVO",
        value: "OVO",
    },
    {
        label: "DANA",
        value: "DANA",
    },
    {
        label: "ShopeePay",
        value: "SHOPEEPAY",
    },
    {
        label: "LinkAja",
        value: "LINKAJA",
    },
    {
        label: "Jenius Pay",
        value: "JENIUSPAY",
    },
    {
        label: "Alfamart / Alfamidi",
        value: "ALFAMART",
    },
    {
        label: "Indomaret",
        value: "INDOMARET",
    },
    {
        label: "QRIS",
        value: "QRIS",
    },
]);

export namespace PaymentChannelEnum {
    export type Labels = (typeof PaymentChannelEnum)["labels"][number];
    export type Values = (typeof PaymentChannelEnum)["values"][number];
}
